export default __webpack_public_path__ + "static/media/github.07646000.svg";